var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.896914 1.054L0.969914 0.970001C1.0969 0.842984 1.26526 0.765755 1.44436 0.752359C1.62347 0.738962 1.80144 0.790287 1.94591 0.897001L2.02991 0.970001L6.99991 5.939L11.9699 0.969001C12.097 0.842133 12.2654 0.76509 12.4446 0.751877C12.6237 0.738664 12.8016 0.79016 12.9459 0.897001L13.0299 0.970001C13.1569 1.09699 13.2342 1.26534 13.2476 1.44445C13.261 1.62356 13.2096 1.80153 13.1029 1.946L13.0299 2.03L8.06091 7L13.0309 11.97C13.1578 12.0971 13.2348 12.2655 13.248 12.4446C13.2613 12.6237 13.2098 12.8016 13.1029 12.946L13.0299 13.03C12.9029 13.157 12.7346 13.2342 12.5555 13.2476C12.3764 13.261 12.1984 13.2097 12.0539 13.103L11.9699 13.03L6.99991 8.061L2.02991 13.031C1.9028 13.1579 1.73438 13.2349 1.55528 13.2481C1.37617 13.2613 1.19827 13.2098 1.05391 13.103L0.969914 13.03C0.842896 12.903 0.765668 12.7347 0.752271 12.5555C0.738875 12.3764 0.7902 12.1985 0.896914 12.054L0.969914 11.97L5.93891 7L0.968914 2.03C0.842046 1.90289 0.765002 1.73447 0.751789 1.55536C0.738577 1.37626 0.790072 1.19836 0.896914 1.054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCloseIcon);
export default __webpack_public_path__ + "static/media/profileCloseIcon.f254014028ad321711079bf276df13c4.svg";
export { ForwardRef as ReactComponent };